
import { defineComponent } from "vue";
import runEvn from "../../modular/runEvn/RunEvn";
import { useRouter } from "vue-router";
import { getSuppliesHomeList } from "@/api/NeighborSuppliesAPI";
import { getNeighborHomeTotal } from '@/api/neighborHomeApi'
// import { getInteractiveHomeList } from "@/api/NeighborInteractive";
import { getLoveHelpHomeList } from "@/api/NeighborLoveHelpApi";
import { getProductHomeList } from "@/api/NeighborProductApi";
import { getCloudClassRoom } from "@/api/CloudClassRoomAPI";
import { getCarouseImg } from '@/api/CarouseImgApi';
import { getHomeList as getInteractiveHomeList } from '@/api/interactiveApi';
import cloudClassItem from '@/views/mulin/components/cloudClassItem.vue'
import HelpWithLoveItem from "./components/HelpWithLoveItem2.vue";
import SuppliesItem from '@/views/mulin/components/SuppliesItem.vue'
import interactiveOrActivity from '@/views/mulin/components/InteractiveOrActivity.vue'
import { Toast } from 'vant'
const fileBaseUrl = runEvn().fileBaseUrl;



export default defineComponent({
	setup() {
		const router = useRouter();
		return {
			router,
		};
	},
	components: {
		HelpWithLoveItem,
		interactiveOrActivity,
		cloudClassItem,
		SuppliesItem
	},
	mounted() {
		this.loadData();
	},
	data() {
		return {
			/**
			 * 顶部统计数据
			 */
			homeTotal: { totalPoint: 0, serviceTime: 0, helpCount: 0 },
			/**
			 * 幻灯片
			 */
			carouseImg: [],
			cloudClassRoomList: [],
			formDataInteractive: [],
			formDataLoveHelp: {},
			formDataSupplies: [],
			formDataProduct: [],
		};
	},
	methods: {
		goShop(itemData) {
			this.router.push(`/shop/goods/detail/${itemData.id}`);
		},
		img(keys: string) {
			const key = keys.split(',')[0];
			if (!key) return '';
			return fileBaseUrl + key;
		},
		async initCarouseImg() {
			const data = await getCarouseImg(5);
			this.carouseImg = data.rows;
		},
		async initHomeTotal() {
			this.homeTotal = await getNeighborHomeTotal();
		},
		// 友邻互助-互动咨询
		async initInteractiveHomeList() {
			let params = {
				pageNum: 1,
				pageSize: 4,
			};
			let Promise: any = await getInteractiveHomeList(params);
			if (Promise) {
				this.formDataInteractive = Promise.rows;
			}
		},
		// 友邻互助-爱心求助
		async initLoveHelpHomeList() {
			const params = {
				pageNum: 1,
				pageSize: 2,
			};
			const Promise: any = await getLoveHelpHomeList(params);
			if (Promise) {
				this.formDataLoveHelp = Promise.rows;
			}
		},
		// 云课堂
		async initCloudClassRoom() {
			const params = {
				pageNum: 1,
				pageSize: 2,
			};
			const data: any = await getCloudClassRoom(params);
			this.cloudClassRoomList = data.rows;
		},
		// 物资捐赠
		async initSuppliesHomeList() {
			const params = {
				pageNum: 1,
				pageSize: 4,
			};
			let Promise: any = await getSuppliesHomeList(params);
			if (Promise) {
				this.formDataSupplies = Promise.rows;
			}
		},
		async loadData() {
			this.initHomeTotal();
			this.initCarouseImg();
			await this.initInteractiveHomeList();
			this.getProduct();
			this.initCloudClassRoom();
			this.initLoveHelpHomeList();
			this.initSuppliesHomeList();
		},
		async getProduct() {
			let params = {
				pageNum: 1,
				pageSize: 4,
			};
			let Promise: any = await getProductHomeList(params);
			if (Promise) {
				this.formDataProduct = Promise.rows;
			}
		},
		gotoServiceDuration() {
			this.$router.push('/mulin/serviceDuration');
		},
		gotoDonationList() {
			this.$router.push('/mulin/donationList');
		},
		gotoHelpList() {
			this.$router.push('/mulin/mutualAid/all')
		},

		nav(item:any) {
			if (item.url) {
				window.open(item.url);
			}
		}

	}
});
